<template>
  <div class="">
    <v-layout row wrap>
      <v-flex lg12 md12 sm12 xs12>
        <v-card flat>
          <h4 class="earth-color">ACCOUNT DETAILS</h4>
          <p><b>Full Name:</b> {{$allPublicUserBookings[0].full_name}}</p>
          <p><b>Email:</b> {{$allPublicUserBookings[0].email}}</p>
        </v-card>
      </v-flex>
    </v-layout>

    <v-layout row wrap>
      <v-flex lg12 md12 sm12 xs12>
        <v-tabs  light slider-color="primary">
          <v-tab key="bookings" class="earth">BOOKINGS</v-tab>
          <v-tab key="finance" @click="fetchFinancial()" class="earth">FINANCE</v-tab>
          <v-tab key="offers" class="earth">OFFERS</v-tab>
          <v-tab-item key="bookings">
            <v-card flat>
              <v-data-table
                :headers="columns"
                :items="$allPublicUserBookings"
                :search="bookings_search"
                :loading="$loadingTrue"
                :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
                :disable-initial-sort="true"
              >
                <v-progress-linear
                  slot="progress"
                  color="primary"
                  indeterminate
                ></v-progress-linear>
                <template slot="items" slot-scope="props">
                    <td>{{ formated_date(props.item.created_at) }}</td>
                  <td>
                    <router-link
                      :to="{
                        name: 'Booking',
                        params: { booking_id: props.item.booking_public_id },
                      }"
                      ><a class="text-dark"
                        ><u>{{ props.item.booking_ref_code }}</u></a
                      ></router-link
                    >
                  </td>
                 
                  <td>{{ formated_date(props.item.booking_check_in_date) }} <b>-</b> {{ formated_date(props.item.booking_check_out_date) }}</td>
                  
                 
                  <td>{{ props.item.booking_status }}</td>
                  <td>{{ props.item.payment_status }}</td>
                  <td>{{ props.item.currency }} {{  props.item.booking_total }}</td>
                  <td>
                    <v-btn
                      :depressed="true"
                      small
                      @click="openBooking(props.item.booking_public_id)"
                      >View Booking</v-btn
                    >
                  </td>
                </template>
                <v-alert
                  slot="no-results"
                  :value="true"
                  color="error"
                  icon="warning"
                >
                  Your search for "{{ bookings_search }}" found no results.
                </v-alert>
              </v-data-table>
              <div>
                <v-btn
                  :depressed="true"
                  @click="getMore()"
                  color="info"
                  :loading="this.$store.state.LoadingStore.loading"
                  >GET MORE</v-btn
                >
                <v-btn
                  :depressed="true"
                  @click="getAllBookings()"
                  color="default"
                  :loading="this.$store.state.LoadingStore.loading"
                  >GET ALL</v-btn
                >
                <v-flex>
                  <v-btn
                    color="error"
                    :depressed="true"
                    @click="generateReportExcel()"
                    :loading="this.$store.state.LoadingStore.loading"
                    >GENERATE REPORT (EXCEL BETA)</v-btn
                  >
                </v-flex>

                <v-btn
                  color="warning"
                  :depressed="true"
                  @click="generateReportCSV()"
                  :loading="this.$store.state.LoadingStore.loading"
                  >GENERATE REPORT (CSV BETA)</v-btn
                >
              </div>
            </v-card>
          </v-tab-item>
          <v-tab-item key="finance">
            <v-card flat>
              
              <v-data-table
                :headers="financeColumns"
                :items="$allBookingUserStatement"
                :search="search"
                :loading="$loadingTrue"
                :disable-initial-sort="true"
              >
                <v-progress-linear
                  slot="progress"
                  color="primary"
                  indeterminate
                ></v-progress-linear>
                <template slot="items" slot-scope="props">
                  <td>{{ formated_date(props.item.sales_date) }}</td>
                  <td>{{ props.item.transaction_reference }}</td>
                  <td>{{ props.item.description }}</td>
                  <td>{{ props.item.currency }}</td>
                  <td>{{ props.item.conversion_rate }}</td>
                  <td>{{ props.item.debit }}</td>
                  <td>{{ props.item.credit }}</td>
                  <td>{{ props.item.running_balance }}</td>
                
                 
                </template>
                <v-alert
                  slot="no-results"
                  :value="true"
                  color="error"
                  icon="warning"
                >
                  Your search for "{{ search }}" found no results.
                </v-alert>
              </v-data-table>
            </v-card>
          </v-tab-item>
          <v-tab-item key="offers">
            <v-card flat>
            
              <!-- <v-data-table
                :headers="destinationColumns"
                :items="allPartnerDestinations"
                :search="search"
                :loading="$loadingTrue"
              >
                <v-progress-linear
                  slot="progress"
                  color="primary"
                  indeterminate
                ></v-progress-linear>
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.destination_name }}</td>
                </template>
                <v-alert
                  slot="no-results"
                  :value="true"
                  color="error"
                  icon="warning"
                >
                  Your search for "{{ search }}" found no results.
                </v-alert>
              </v-data-table> -->
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-flex>
    </v-layout>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      suspend_count: 3,
      activate_count: 3,
      search: "",
      bookings_search: "",
      page: 2,
      columns: [
      {
          text: "Creation Date",
          value: "created_at",
        },
        {
          text: "Ref",
          value: "booking_ref_code",
        },
       
        {
          text: "Booking Dates",
          value: "booking_check_in_date",
        },
       
      
        {
          text: "Booking Status",
          value: "booking_status",
        },
        {
          text: "Payment Status",
          value: "payment_status",
        },
        {
          text: "Booking Total",
          value: "booking_total",
        },
        {
          text: "Action",
          value: "",
        },
      ],
      financeColumns: [
        {
          text: "Date",
          value: "sales_date",
        },
        {
          text: "Transaction Reference",
          value: "transaction_reference",
        },
        {
          text: "Description",
          value: "description",
        },
        {
          text: "Currency Code",
          value: "currency",
        },
        {
          text: "Rates",
          value: "conversion_rate",
        },
        {
          text: "Debit",
          value: "debit",
        },
        {
          text: "Credit",
          value: "credit",
        },
        {
          text: "Running Balance",
          value: "running_balance",
        },
       
      ],
      destinationColumns: [
        {
          text: "Name",
          value: "destination_name",
        },
      ],
    };
  },
  methods: {
    fetchFinancial: function () {
        let public_user_id =  this.$route.params.public_user_id
        let data  = this.$store.state.BookingStore.finanace_statement
        if( data.length ==0 || data ==undefined ){
          this.$store.dispatch("get_finance_statements", public_user_id);

        }
       
    },
    editPartner: function () {
      this.$router.push({
        name: "EditPartner",
        params: {
          partner_id: this.$route.params.partner_id,
        },
      });
    },
    openBooking: function (publicId) {
      this.$router.push({
        name: "Booking",
        params: {
          booking_id: publicId,
        },
      });
    },
    getMore() {
      this.loading = true;
      let data = {
        publicId: this.$route.params.partner_id,
        page: this.page,
      };
      if (this.page === 2) {
        this.$store.dispatch("get_partner_bookings_streaming", data);
        this.page = this.page + 1;
      } else {
        this.$store.dispatch("get_partner_bookings_streaming", data);
        this.page = this.page + 1;
      }
    },
    getAllBookings() {
      this.loading = true;
      let data = {
        publicId: this.$route.params.partner_id,
        page: 0,
      };
      this.$store.dispatch("get_partner_bookings_streaming", data);
    },
    generateReportCSV() {
      var idList = [];
      this.$filterPartnerBooking.map(function (booking) {
        idList.push(booking.booking_public_id);
      });
      var data = {
        booking_ids: idList,
        print_format: "CSV",
        session_id: localStorage.getItem("lkjhgfdsa"),
      };
      this.$store.dispatch("generate_formatted_csv", data);
    },
    generateReportExcel() {
      var idList = [];
      this.$filterPartnerBooking.map(function (booking) {
        idList.push(booking.booking_public_id);
      });
      var data = {
        booking_ids: idList,
        print_format: "xls",
        session_id: localStorage.getItem("lkjhgfdsa"),
      };
      this.$store.dispatch("generate_formatted_csv", data);
    },
    activateAccount: function () {
      if (this.activate_count > 0) {
        this.activate_count = this.activate_count - 1;
      } else {
        var data = {
          public_id: this.$route.params.partner_id,
          session_id: localStorage.getItem("lkjhgfdsa"),
        };
        this.$store.dispatch("activate_partner", data);
      }
    },
    suspendAccount: function () {
      if (this.suspend_count > 0) {
        this.suspend_count = this.suspend_count - 1;
      } else {
        var data = {
          public_id: this.$route.params.partner_id,
          session_id: localStorage.getItem("lkjhgfdsa"),
        };
        this.$store.dispatch("suspend_partner", data);
      }
    },
  },
  created() {
    this.$store.dispatch("get_puser_bookings", this.$route.params.public_user_id);
  },
};
// TODO changes
</script>
  
  <style>
</style>
  